import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  templateUrl: './invalid-time-dialog.component.html',
  styleUrls: ['./invalid-time-dialog.component.scss']
})
export class InvalidTimeDialogComponent implements OnInit {

  public errors!: any[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    if (this.data.errors) {
      this.errors = Object.keys(this.data.errors).map(key => { 
        return this.data.errors[key]; 
      });
    }
  }

}
